import React from "react";
import { Form } from "react-bootstrap";
import { ErrorMessage } from "formik";

export default function OthersTabFields({
  values,
  handleChange,
  setFieldValue,
}) {
  return (
    <>
      <div className="row g-0">
        <div className="col-md-6 pe-md-4 pe-0 mb-4">
          <Form.Label>
            Would you allow your Child / Children to appear on camp
            promotionals, electronic publications and event updates?
          </Form.Label>
          <Form.Check
            type="radio"
            name="otherPromotionals"
            id="promotionalYes"
            label="Yes"
            className="me-3"
            value="yes"
            onChange={(e) =>
              e.target.checked
                ? setFieldValue("otherPromotionals", e.target.value)
                : ""
            }
            checked={values.otherPromotionals === "yes"}
          />
          <Form.Check
            type="radio"
            name="otherPromotionals"
            id="promotionalNo"
            label="No"
            value="no"
            onChange={(e) =>
              e.target.checked
                ? setFieldValue("otherPromotionals", e.target.value)
                : ""
            }
            checked={values.otherPromotionals === "no"}
          />
          <ErrorMessage
            name="otherPromotionals"
            component="p"
            className="error-message"
          />
        </div>
        <div className="col-md-6 mb-4">
          <div className="mb-4">
            <Form.Label>
              From time to time we may send your child home with activity packs
              containing recipes and ingredients, do any members of your
              household have allergies or specific dietary requirements?
            </Form.Label>
            <div className="d-flex">
              <Form.Check
                type="radio"
                name="otherPrecautions"
                id="otherPrecautionsYes"
                label="Yes"
                className="me-3"
                value="yes"
                onChange={(e) =>
                  e.target.checked
                    ? setFieldValue("otherPrecautions", e.target.value)
                    : ""
                }
                checked={values.otherPrecautions === "yes"}
              />
              <Form.Check
                type="radio"
                name="otherPrecautions"
                id="otherPrecautionsNo"
                label="No"
                value="no"
                onChange={(e) =>
                  e.target.checked
                    ? setFieldValue("otherPrecautions", e.target.value)
                    : ""
                }
                checked={values.otherPrecautions === "no"}
              />
            </div>
            <ErrorMessage
              name="otherPrecautions"
              component="p"
              className="error-message"
            />
          </div>
          <div>
            <Form.Label>
              Do you have frequent access to the internet?
            </Form.Label>
            <div className="d-flex">
              <Form.Check
                type="radio"
                name="otherInternetAccess"
                id="otherInternetAccessYes"
                label="Yes"
                className="me-3"
                value="yes"
                onChange={(e) =>
                  e.target.checked
                    ? setFieldValue("otherInternetAccess", e.target.value)
                    : ""
                }
                checked={values.otherInternetAccess === "yes"}
              />
              <Form.Check
                type="radio"
                name="otherInternetAccess"
                id="otherInternetAccessNo"
                label="No"
                value="no"
                onChange={(e) =>
                  e.target.checked
                    ? setFieldValue("otherInternetAccess", e.target.value)
                    : ""
                }
                checked={values.otherInternetAccess === "no"}
              />
            </div>
            <ErrorMessage
              name="otherInternetAccess"
              component="p"
              className="error-message"
            />
          </div>
        </div>
      </div>
      <div className="row g-0">
        <div className="col-md-6 pe-md-4 pe-0 mb-4">
          <Form.Label>How did you hear about the programme?</Form.Label>
          <Form.Check
            type="radio"
            name="otherLeadSource"
            id="leadsource1"
            label="Leaflet handed by school"
            value="Leaflet handed by school"
            onChange={(e) =>
              e.target.checked
                ? setFieldValue("otherLeadSource", e.target.value)
                : ""
            }
            checked={values.otherLeadSource === "Leaflet handed by school"}
          />
          <Form.Check
            type="radio"
            name="otherLeadSource"
            id="leadsource2"
            label="Email by school"
            value="Email by school"
            onChange={(e) =>
              e.target.checked
                ? setFieldValue("otherLeadSource", e.target.value)
                : ""
            }
            checked={values.otherLeadSource === "Email by school"}
          />
          <Form.Check
            type="radio"
            name="otherLeadSource"
            id="leadsource3"
            label="Leaflet handed in the park/street"
            value="Leaflet handed in the park/street"
            onChange={(e) =>
              e.target.checked
                ? setFieldValue("otherLeadSource", e.target.value)
                : ""
            }
            checked={
              values.otherLeadSource === "Leaflet handed in the park/street"
            }
          />
          <Form.Check
            type="radio"
            name="otherLeadSource"
            id="leadsource4"
            label="Word of mouth"
            value="Word of mouth"
            onChange={(e) =>
              e.target.checked
                ? setFieldValue("otherLeadSource", e.target.value)
                : ""
            }
            checked={values.otherLeadSource === "Word of mouth"}
          />
          <Form.Check
            type="radio"
            name="otherLeadSource"
            id="leadsource5"
            label="Email from Bubbles & Smiles"
            value="Email from Bubbles & Smiles"
            onChange={(e) =>
              e.target.checked
                ? setFieldValue("otherLeadSource", e.target.value)
                : ""
            }
            checked={values.otherLeadSource === "Email from Bubbles & Smiles"}
          />
          <Form.Check
            type="radio"
            name="otherLeadSource"
            id="leadsource6"
            label="Text / whatsApp from Bubbles & Smiles"
            value="Text / whatsApp from Bubbles & Smiles"
            onChange={(e) =>
              e.target.checked
                ? setFieldValue("otherLeadSource", e.target.value)
                : ""
            }
            checked={
              values.otherLeadSource === "Text / whatsApp from Bubbles & Smiles"
            }
          />
          <Form.Check
            type="radio"
            name="otherLeadSource"
            id="leadsource7"
            label="Social Media"
            value="Social Media"
            onChange={(e) =>
              e.target.checked
                ? setFieldValue("otherLeadSource", e.target.value)
                : ""
            }
            checked={values.otherLeadSource === "Social Media"}
          />
          <Form.Check
            type="radio"
            name="otherLeadSource"
            id="leadsource8"
            label="My child is a member / regularly attend the club events"
            value="My child is a member / regularly attend the club events"
            onChange={(e) =>
              e.target.checked
                ? setFieldValue("otherLeadSource", e.target.value)
                : ""
            }
            checked={
              values.otherLeadSource ===
              "My child is a member / regularly attend the club events"
            }
          />
          <ErrorMessage
            name="otherLeadSource"
            component="p"
            className="error-message"
          />
        </div>
        <div className="col-md-6 mb-4">
          <Form.Label>
            Our programmes are run by 90% volunteers, would you like us to
            contact you to volunteer whenever you can?
          </Form.Label>
          <Form.Check
            type="radio"
            name="otherVolunteer"
            id="otherVolunteer1"
            label="Yes"
            className="me-3"
            value="Yes"
            onChange={(e) =>
              e.target.checked
                ? setFieldValue("otherVolunteer", e.target.value)
                : ""
            }
            checked={values.otherVolunteer === "yes"}
          />
          <Form.Check
            type="radio"
            name="otherVolunteer"
            id="otherVolunteer2"
            label="Will let you know when I can"
            value="Will let you know when I can"
            onChange={(e) =>
              e.target.checked
                ? setFieldValue("otherVolunteer", e.target.value)
                : ""
            }
            checked={values.otherVolunteer === "Will let you know when I can"}
          />
          <Form.Check
            type="radio"
            name="otherVolunteer"
            id="otherVolunteer3"
            label="May be"
            value="May be"
            onChange={(e) =>
              e.target.checked
                ? setFieldValue("otherVolunteer", e.target.value)
                : ""
            }
            checked={values.otherVolunteer === "May be"}
          />
          <Form.Check
            type="radio"
            name="otherVolunteer"
            id="otherVolunteer4"
            label="Sorry I am too busy"
            value="Sorry I am too busy"
            onChange={(e) =>
              e.target.checked
                ? setFieldValue("otherVolunteer", e.target.value)
                : ""
            }
            checked={values.otherVolunteer === "Sorry I am too busy"}
          />
          <ErrorMessage
            name="otherVolunteer"
            component="p"
            className="error-message"
          />
          <div className="mt-4">
            <Form.Label>
              For us to ensure all communities are well represented, what is
              your ethnic background?
            </Form.Label>
            <Form.Control
              type="text"
              name="otherEthnicity"
              placeholder="Enter your ethnic background"
              value={values.otherEthnicity}
              onChange={handleChange}
            />
            <ErrorMessage
              name="otherEthnicity"
              component="p"
              className="error-message"
            />
          </div>
        </div>
      </div>
    </>
  );
}
